import React from 'react';

export default function ContactUs() {
  const styles = {
    container: {
      padding: '20px',
      maxWidth: '768px',
      margin: '0 auto',
    },
    heading: {
      fontSize: '24px',
      textAlign: 'center',
      marginBottom: '16px',
    },
    paragraph: {
      marginBottom: '12px',
      lineHeight: '1.6',
      fontSize: '16px'
    },
    email: {
      fontWeight: 'bold',
      fontSize: '16px'
    }
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Contact Us</h1>
      <p style={styles.paragraph}>Do you have suggestions, questions, advertise with us, or feedback? The only thing you have to do is send us a message. We typically respond to messages within 24-48 hours.</p>
      <p style={styles.paragraph}>Email: <span style={styles.email}>contact@downr.org</span></p>
    </div>
  );
}